"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const roomFilterState_1 = require("./roomFilterState");
const userInfoState_1 = __importDefault(require("@/common/components/NavHeader/userInfoState"));
const react_query_1 = require("@tanstack/react-query");
const api_1 = require("@/api");
const components_1 = require("@/common/components");
const useIsDataFetching_1 = __importDefault(require("@/common/functions/useIsDataFetching"));
const detect_utils_1 = require("@/common/detect_utils");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const _1 = require(".");
function default_1({ setShowMainFooter, }) {
    const roomTypeFilter = (0, recoil_1.useRecoilValue)(roomFilterState_1.roomTypeFilterState);
    const isRoomTypeRecent = roomTypeFilter === '';
    const isRoomTypeDemandSurvey = roomTypeFilter === 'demand'; // ? 페이폼 없음
    const isRoomTypeCommission = roomTypeFilter === 'commission'; // ? 페이폼만 있음
    // ! 전체 or 페이폼 필터는 'demand'와 'commission'에 필요 없음
    const payformFilter = (0, recoil_1.useRecoilValue)(roomFilterState_1.payformFilterState);
    const isPayformFilter = !isRoomTypeDemandSurvey && !isRoomTypeCommission && payformFilter;
    const { id: categoryFilterId } = (0, recoil_1.useRecoilValue)(roomFilterState_1.categoryFilterState);
    const hasCategory = !!categoryFilterId;
    const { ready: isUserInfoReady, isLoggedIn } = (0, recoil_1.useRecoilValue)(userInfoState_1.default);
    const isFirstVisit = !hasCategory && !isLoggedIn;
    const isPopMain = isRoomTypeRecent && isFirstVisit;
    const isRecentMain = isRoomTypeRecent && !isFirstVisit;
    const mainRoomPath = isPopMain
        ? `${detect_utils_1.fondeeSearchOrigin}/api/v1/rooms/pop-main`
        : `/api/v1/fondee/room`;
    const getMainRoomUrl = (cursor) => {
        let queryParams = new URLSearchParams();
        isPayformFilter && queryParams.append('payFilter', 'true');
        if (isPopMain) {
            !!cursor && queryParams.append('cursor', cursor);
        }
        else if (isRecentMain) {
            hasCategory && queryParams.append('category', categoryFilterId);
        }
        else {
            queryParams.append('type', roomTypeFilter);
        }
        const queryParamString = String(queryParams);
        return `${mainRoomPath}${queryParamString ? `?${queryParamString}` : ''}`;
    };
    const getNextPageUrl = (data) => {
        if (isPopMain) {
            const nextCursor = data.meta.cursor;
            return nextCursor ? getMainRoomUrl(nextCursor) : undefined;
        }
        else {
            const nextUrl = data.meta.next;
            return nextUrl !== null && nextUrl !== void 0 ? nextUrl : undefined;
        }
    };
    const { isLoading, isFetching, data, fetchNextPage, isFetchingNextPage, hasNextPage } = (0, react_query_1.useInfiniteQuery)(['roomsData', roomTypeFilter, categoryFilterId, isPayformFilter], ({ pageParam: nextPageUrl }) => __awaiter(this, void 0, void 0, function* () {
        const fetchUrl = nextPageUrl || getMainRoomUrl();
        const { data } = yield (0, api_1.getData)(fetchUrl);
        if (isPopMain) {
            return { result: data.result, meta: { cursor: data.cursor } };
        }
        else
            return data;
    }), {
        getNextPageParam: getNextPageUrl,
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: isUserInfoReady,
    });
    (0, useIsDataFetching_1.default)(isFetching);
    (0, react_1.useEffect)(() => {
        if (hasNextPage === false) {
            setShowMainFooter(true);
        }
        else if (hasNextPage) {
            setShowMainFooter(false);
        }
    }, [hasNextPage]);
    const getRenderData = () => {
        if (data)
            return data.pages.flatMap(obj => obj.result);
        else
            return [];
    };
    const renderData = (0, react_1.useMemo)(getRenderData, [data]);
    const hasRenderData = !!renderData.length;
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const maxWidth1024 = (0, useMediaQuery_1.default)('(max-width:1024px)');
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    display: 'flex',
                    flexDirection: 'column',
                    rowGap: '15px',
                    padding: maxWidth1024 ? '0 11px' : 0,
                } }, { children: [(0, jsx_runtime_1.jsx)(_1.MainRoomsRoomTypeFilter, { isUserInfoReady: isUserInfoReady, isFirstVisit: isFirstVisit, hasCategory: hasCategory, isFetching: isFetching }), !isRoomTypeDemandSurvey && !isRoomTypeCommission && ((0, jsx_runtime_1.jsx)(_1.MainRoomsPayformFilter, { isUserInfoReady: isUserInfoReady, isFetching: isFetching }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    position: 'relative',
                    padding: maxWidth768 ? '10px 7px 30px' : maxWidth1024 ? '10px 6px 30px' : '10px 0 30px',
                    margin: maxWidth1024 ? 0 : '0 -5px',
                } }, { children: [(0, jsx_runtime_1.jsx)(_1.MainRoomList, { renderData: renderData, isLoading: isLoading, isLoggedIn: isLoggedIn, maxWidth768: maxWidth768, isPopMain: isPopMain }), (0, jsx_runtime_1.jsx)(components_1.InfiniteScroller, { fetchNextPage: fetchNextPage, isFetchingNextPage: isFetchingNextPage, hasRenderData: hasRenderData, additionalCss: { height: '150px' }, needDelay: hasNextPage })] }))] }));
}
exports.default = default_1;
